export const airFlow = [
  {
    x: 0,
    y: 607.0899,
  },
  {
    x: 20,
    y: 605.4620999999997,
  },
  {
    x: 40,
    y: 605.7333999999996,
  },
  {
    x: 60,
    y: 606.2759999999998,
  },
  {
    x: 80,
    y: 607.0899,
  },
  {
    x: 100,
    y: 607.0899,
  },
  {
    x: 120,
    y: 607.3611999999998,
  },
  {
    x: 140,
    y: 605.4620999999997,
  },
  {
    x: 160,
    y: 601.3925999999997,
  },
  {
    x: 180,
    y: 607.0899,
  },
  {
    x: 200,
    y: 606.2759999999998,
  },
  {
    x: 220,
    y: 607.0899,
  },
  {
    x: 240,
    y: 605.4620999999997,
  },
  {
    x: 260,
    y: 606.2759999999998,
  },
  {
    x: 280,
    y: 604.6481999999996,
  },
  {
    x: 300,
    y: 606.2759999999998,
  },
  {
    x: 320,
    y: 607.0899,
  },
  {
    x: 340,
    y: 604.6481999999996,
  },
  {
    x: 360,
    y: 604.6481999999996,
  },
  {
    x: 380,
    y: 607.0899,
  },
  {
    x: 400,
    y: 607.0899,
  },
  {
    x: 420,
    y: 607.0899,
  },
  {
    x: 440,
    y: 607.0899,
  },
  {
    x: 460,
    y: 607.9037999999996,
  },
  {
    x: 480,
    y: 606.2759999999998,
  },
  {
    x: 500,
    y: 607.0899,
  },
  {
    x: 520,
    y: 607.0899,
  },
  {
    x: 540,
    y: 606.2759999999998,
  },
  {
    x: 560,
    y: 606.2759999999998,
  },
  {
    x: 580,
    y: 606.2759999999998,
  },
  {
    x: 600,
    y: 606.2759999999998,
  },
  {
    x: 620,
    y: 606.2759999999998,
  },
  {
    x: 640,
    y: 5.617799999999988,
  },
  {
    x: 660,
    y: 4.803899999999885,
  },
  {
    x: 680,
    y: -0.07950000000028012,
  },
  {
    x: 700,
    y: -0.07950000000028012,
  },
  {
    x: 720,
    y: -0.07950000000028012,
  },
  {
    x: 740,
    y: 1.005699999999706,
  },
  {
    x: 760,
    y: 1.005699999999706,
  },
  {
    x: 780,
    y: 1.8195999999998094,
  },
  {
    x: 800,
    y: 1.005699999999706,
  },
  {
    x: 820,
    y: 1.005699999999706,
  },
  {
    x: 840,
    y: 1.005699999999706,
  },
  {
    x: 860,
    y: 1.005699999999706,
  },
  {
    x: 880,
    y: 1.005699999999706,
  },
  {
    x: 900,
    y: 1.005699999999706,
  },
  {
    x: 920,
    y: 1.005699999999706,
  },
  {
    x: 940,
    y: 1.005699999999706,
  },
  {
    x: 960,
    y: 1.005699999999706,
  },
  {
    x: 980,
    y: 1.005699999999706,
  },
  {
    x: 1000,
    y: 1.005699999999706,
  },
  {
    x: 1020,
    y: 1.005699999999706,
  },
  {
    x: 1040,
    y: 1.5482999999999265,
  },
  {
    x: 1060,
    y: -613.4888000000001,
  },
  {
    x: 1080,
    y: -1102.9140000000002,
  },
  {
    x: 1100,
    y: -859.5579000000002,
  },
  {
    x: 1120,
    y: -868.5108,
  },
  {
    x: 1140,
    y: -853.5893000000001,
  },
  {
    x: 1160,
    y: -796.3450000000003,
  },
  {
    x: 1180,
    y: -792.0042000000003,
  },
  {
    x: 1200,
    y: -759.9908,
  },
  {
    x: 1220,
    y: -725.5357000000004,
  },
  {
    x: 1240,
    y: -710.0716000000002,
  },
  {
    x: 1260,
    y: -693.5223000000001,
  },
  {
    x: 1280,
    y: -692.1658000000002,
  },
  {
    x: 1300,
    y: -678.8721,
  },
  {
    x: 1320,
    y: -670.7330999999999,
  },
  {
    x: 1340,
    y: -655.8116,
  },
  {
    x: 1360,
    y: -630.5807,
  },
  {
    x: 1380,
    y: -617.0156999999999,
  },
  {
    x: 1400,
    y: -603.7220000000002,
  },
  {
    x: 1420,
    y: -589.6143999999999,
  },
  {
    x: 1440,
    y: -575.5068000000001,
  },
  {
    x: 1460,
    y: -564.9261000000001,
  },
  {
    x: 1480,
    y: -542.6795000000002,
  },
  {
    x: 1500,
    y: -529.1145000000001,
  },
  {
    x: 1520,
    y: -525.5876000000003,
  },
  {
    x: 1540,
    y: -493.5742,
  },
  {
    x: 1560,
    y: -482.4509000000003,
  },
  {
    x: 1580,
    y: -460.20430000000033,
  },
  {
    x: 1600,
    y: -446.09670000000006,
  },
  {
    x: 1620,
    y: -430.90390000000025,
  },
  {
    x: 1640,
    y: -414.6259,
  },
  {
    x: 1660,
    y: -400.5183000000002,
  },
  {
    x: 1680,
    y: -377.45780000000013,
  },
  {
    x: 1700,
    y: -365.5206000000003,
  },
  {
    x: 1720,
    y: -355.2112000000002,
  },
  {
    x: 1740,
    y: -331.33680000000004,
  },
  {
    x: 1760,
    y: -315.05880000000025,
  },
  {
    x: 1780,
    y: -297.96690000000035,
  },
  {
    x: 1800,
    y: -277.8907000000004,
  },
  {
    x: 1820,
    y: -253.20240000000013,
  },
  {
    x: 1840,
    y: -233.94010000000026,
  },
  {
    x: 1860,
    y: -222.00289999999995,
  },
  {
    x: 1880,
    y: -204.09709999999995,
  },
  {
    x: 1900,
    y: -191.61730000000034,
  },
  {
    x: 1920,
    y: -162.58820000000014,
  },
  {
    x: 1940,
    y: -143.32590000000027,
  },
  {
    x: 1960,
    y: -124.60620000000017,
  },
  {
    x: 1980,
    y: -95.57709999999997,
  },
  {
    x: 2000,
    y: -83.63990000000013,
  },
  {
    x: 2020,
    y: -65.19150000000036,
  },
  {
    x: 2040,
    y: -48.09960000000001,
  },
  {
    x: 2060,
    y: -38.332800000000134,
  },
  {
    x: 2080,
    y: -34.534599999999955,
  },
  {
    x: 2100,
    y: -18.799200000000383,
  },
  {
    x: 2120,
    y: -20.427000000000135,
  },
  {
    x: 2140,
    y: -13.915800000000218,
  },
  {
    x: 2160,
    y: -5.505500000000211,
  },
  {
    x: 2180,
    y: -6.319400000000314,
  },
  {
    x: 2200,
    y: -10.117600000000039,
  },
  {
    x: 2220,
    y: 2.6334999999999127,
  },
  {
    x: 2240,
    y: -4.149000000000342,
  },
  {
    x: 2260,
    y: -1.707300000000032,
  },
  {
    x: 2280,
    y: -1.707300000000032,
  },
  {
    x: 2300,
    y: 2.6334999999999127,
  },
  {
    x: 2320,
    y: 1.005699999999706,
  },
  {
    x: 2340,
    y: -1.707300000000032,
  },
  {
    x: 2360,
    y: 4.803899999999885,
  },
  {
    x: 2380,
    y: -2.5212000000001353,
  },
  {
    x: 2400,
    y: 0.46309999999994034,
  },
  {
    x: 2420,
    y: -1.707300000000032,
  },
  {
    x: 2440,
    y: 0.46309999999994034,
  },
  {
    x: 2460,
    y: 0.46309999999994034,
  },
  {
    x: 2480,
    y: 2.6334999999999127,
  },
  {
    x: 2500,
    y: 1.005699999999706,
  },
  {
    x: 2520,
    y: -1.1647000000002663,
  },
  {
    x: 2540,
    y: -1.1647000000002663,
  },
  {
    x: 2560,
    y: -1.707300000000032,
  },
  {
    x: 2580,
    y: -2.5212000000001353,
  },
  {
    x: 2600,
    y: -1.1647000000002663,
  },
  {
    x: 2620,
    y: -1.707300000000032,
  },
  {
    x: 2640,
    y: -2.5212000000001353,
  },
  {
    x: 2660,
    y: -3.3351000000002387,
  },
  {
    x: 2680,
    y: -1.707300000000032,
  },
  {
    x: 2700,
    y: -5.505500000000211,
  },
  {
    x: 2720,
    y: -1.1647000000002663,
  },
  {
    x: 2740,
    y: -1.707300000000032,
  },
  {
    x: 2760,
    y: -2.5212000000001353,
  },
  {
    x: 2780,
    y: -2.5212000000001353,
  },
  {
    x: 2800,
    y: -4.149000000000342,
  },
  {
    x: 2820,
    y: 1.005699999999706,
  },
  {
    x: 2840,
    y: -4.149000000000342,
  },
  {
    x: 2860,
    y: -3.3351000000002387,
  },
  {
    x: 2880,
    y: -3.3351000000002387,
  },
  {
    x: 2900,
    y: -4.149000000000342,
  },
  {
    x: 2920,
    y: -3.3351000000002387,
  },
  {
    x: 2940,
    y: -2.5212000000001353,
  },
  {
    x: 2960,
    y: -4.149000000000342,
  },
  {
    x: 2980,
    y: -1.1647000000002663,
  },
  {
    x: 3000,
    y: -3.3351000000002387,
  },
  {
    x: 3020,
    y: -7.133299999999963,
  },
  {
    x: 3040,
    y: -1.707300000000032,
  },
  {
    x: 3060,
    y: -2.5212000000001353,
  },
  {
    x: 3080,
    y: -4.149000000000342,
  },
  {
    x: 3100,
    y: -3.3351000000002387,
  },
  {
    x: 3120,
    y: 1.005699999999706,
  },
  {
    x: 3140,
    y: -4.149000000000342,
  },
  {
    x: 3160,
    y: -2.5212000000001353,
  },
  {
    x: 3180,
    y: -6.319400000000314,
  },
  {
    x: 3200,
    y: 1.8195999999998094,
  },
  {
    x: 3220,
    y: -5.505500000000211,
  },
  {
    x: 3240,
    y: 0.46309999999994034,
  },
  {
    x: 3260,
    y: -2.5212000000001353,
  },
  {
    x: 3280,
    y: -1.707300000000032,
  },
  {
    x: 3300,
    y: -3.3351000000002387,
  },
  {
    x: 3320,
    y: -2.5212000000001353,
  },
  {
    x: 3340,
    y: -3.3351000000002387,
  },
  {
    x: 3360,
    y: 1.005699999999706,
  },
  {
    x: 3380,
    y: -1.1647000000002663,
  },
  {
    x: 3400,
    y: -7.133299999999963,
  },
  {
    x: 3420,
    y: -1.1647000000002663,
  },
  {
    x: 3440,
    y: -3.3351000000002387,
  },
  {
    x: 3460,
    y: -1.1647000000002663,
  },
  {
    x: 3480,
    y: -4.149000000000342,
  },
  {
    x: 3500,
    y: -1.707300000000032,
  },
  {
    x: 3520,
    y: -1.707300000000032,
  },
  {
    x: 3540,
    y: -1.707300000000032,
  },
  {
    x: 3560,
    y: 0.46309999999994034,
  },
  {
    x: 3580,
    y: -2.5212000000001353,
  },
  {
    x: 3600,
    y: -2.5212000000001353,
  },
  {
    x: 3620,
    y: -1.1647000000002663,
  },
  {
    x: 3640,
    y: -3.3351000000002387,
  },
  {
    x: 3660,
    y: -2.5212000000001353,
  },
  {
    x: 3680,
    y: -1.707300000000032,
  },
  {
    x: 3700,
    y: -1.1647000000002663,
  },
  {
    x: 3720,
    y: 1.005699999999706,
  },
  {
    x: 3740,
    y: 47.940599999999904,
  },
  {
    x: 3760,
    y: 120.3777,
  },
  {
    x: 3780,
    y: 199.32600000000002,
  },
  {
    x: 3800,
    y: 269.3213999999998,
  },
  {
    x: 3820,
    y: 343.6576,
  },
  {
    x: 3840,
    y: 416.90859999999975,
  },
  {
    x: 3860,
    y: 494.2291,
  },
  {
    x: 3880,
    y: 566.1235999999999,
  },
  {
    x: 3900,
    y: 606.5472999999997,
  },
  {
    x: 3920,
    y: 607.0899,
  },
  {
    x: 3940,
    y: 607.9037999999996,
  },
  {
    x: 3960,
    y: 607.0899,
  },
  {
    x: 3980,
    y: 607.0899,
  },
  {
    x: 4000,
    y: 605.7333999999996,
  },
  {
    x: 4020,
    y: 607.9037999999996,
  },
  {
    x: 4040,
    y: 604.1055999999999,
  },
  {
    x: 4060,
    y: 607.0899,
  },
  {
    x: 4080,
    y: 606.2759999999998,
  },
  {
    x: 4100,
    y: 607.9037999999996,
  },
  {
    x: 4120,
    y: 607.9037999999996,
  },
  {
    x: 4140,
    y: 605.4620999999997,
  },
  {
    x: 4160,
    y: 603.8343,
  },
  {
    x: 4180,
    y: 606.2759999999998,
  },
  {
    x: 4200,
    y: 608.9889999999996,
  },
  {
    x: 4220,
    y: 605.4620999999997,
  },
  {
    x: 4240,
    y: 605.7333999999996,
  },
  {
    x: 4260,
    y: 603.0203999999999,
  },
  {
    x: 4280,
    y: 607.0899,
  },
  {
    x: 4300,
    y: 607.0899,
  },
  {
    x: 4320,
    y: 607.0899,
  },
  {
    x: 4340,
    y: 608.7176999999997,
  },
  {
    x: 4360,
    y: 608.7176999999997,
  },
  {
    x: 4380,
    y: 604.6481999999996,
  },
  {
    x: 4400,
    y: 606.2759999999998,
  },
  {
    x: 4420,
    y: 607.0899,
  },
  {
    x: 4440,
    y: 606.2759999999998,
  },
  {
    x: 4460,
    y: 606.2759999999998,
  },
  {
    x: 4480,
    y: 605.7333999999996,
  },
  {
    x: 4500,
    y: 607.9037999999996,
  },
  {
    x: 4520,
    y: 606.2759999999998,
  },
  {
    x: 4540,
    y: 607.0899,
  },
  {
    x: 4560,
    y: 606.2759999999998,
  },
  {
    x: 4580,
    y: 607.0899,
  },
  {
    x: 4600,
    y: 606.2759999999998,
  },
  {
    x: 4620,
    y: 605.7333999999996,
  },
  {
    x: 4640,
    y: 7.516899999999623,
  },
  {
    x: 4660,
    y: 5.617799999999988,
  },
  {
    x: 4680,
    y: -0.07950000000028012,
  },
  {
    x: 4700,
    y: -0.07950000000028012,
  },
  {
    x: 4720,
    y: -0.07950000000028012,
  },
  {
    x: 4740,
    y: 1.005699999999706,
  },
  {
    x: 4760,
    y: 1.005699999999706,
  },
  {
    x: 4780,
    y: 1.8195999999998094,
  },
  {
    x: 4800,
    y: 1.005699999999706,
  },
  {
    x: 4820,
    y: 1.005699999999706,
  },
  {
    x: 4840,
    y: 1.005699999999706,
  },
  {
    x: 4860,
    y: 1.005699999999706,
  },
  {
    x: 4880,
    y: 1.005699999999706,
  },
  {
    x: 4900,
    y: 1.005699999999706,
  },
  {
    x: 4920,
    y: 1.005699999999706,
  },
  {
    x: 4940,
    y: 1.005699999999706,
  },
  {
    x: 4960,
    y: 1.005699999999706,
  },
  {
    x: 4980,
    y: 1.005699999999706,
  },
  {
    x: 5000,
    y: 1.005699999999706,
  },
  {
    x: 5020,
    y: 1.005699999999706,
  },
  {
    x: 5040,
    y: -1.9786000000003696,
  },
  {
    x: 5060,
    y: -487.8769000000002,
  },
  {
    x: 5080,
    y: -1126.7884,
  },
  {
    x: 5100,
    y: -861.7283000000002,
  },
  {
    x: 5120,
    y: -830.5288,
  },
  {
    x: 5140,
    y: -868.5108,
  },
  {
    x: 5160,
    y: -808.2822000000001,
  },
  {
    x: 5180,
    y: -791.1903000000002,
  },
  {
    x: 5200,
    y: -754.0222000000003,
  },
  {
    x: 5220,
    y: -711.4281000000001,
  },
  {
    x: 5240,
    y: -705.7308000000003,
  },
  {
    x: 5260,
    y: -709.2577000000001,
  },
  {
    x: 5280,
    y: -687.0111000000002,
  },
  {
    x: 5300,
    y: -688.3676,
  },
  {
    x: 5320,
    y: -680.2285999999999,
  },
  {
    x: 5340,
    y: -652.0134000000003,
  },
  {
    x: 5360,
    y: -635.7354,
  },
  {
    x: 5380,
    y: -624.6121000000003,
  },
  {
    x: 5400,
    y: -610.2332000000001,
  },
  {
    x: 5420,
    y: -589.6143999999999,
  },
  {
    x: 5440,
    y: -579.8476,
  },
  {
    x: 5460,
    y: -560.5853000000002,
  },
  {
    x: 5480,
    y: -546.2064,
  },
  {
    x: 5500,
    y: -532.3701000000001,
  },
  {
    x: 5520,
    y: -512.0226000000002,
  },
  {
    x: 5540,
    y: -491.40380000000005,
  },
  {
    x: 5560,
    y: -491.40380000000005,
  },
  {
    x: 5580,
    y: -477.2962000000002,
  },
  {
    x: 5600,
    y: -451.2514000000001,
  },
  {
    x: 5620,
    y: -434.7021,
  },
  {
    x: 5640,
    y: -409.47119999999995,
  },
  {
    x: 5660,
    y: -407.3008,
  },
  {
    x: 5680,
    y: -381.2560000000003,
  },
  {
    x: 5700,
    y: -361.9937,
  },
  {
    x: 5720,
    y: -347.88610000000017,
  },
  {
    x: 5740,
    y: -335.1350000000002,
  },
  {
    x: 5760,
    y: -309.9041000000002,
  },
  {
    x: 5780,
    y: -294.9826000000003,
  },
  {
    x: 5800,
    y: -275.72029999999995,
  },
  {
    x: 5820,
    y: -260.7988,
  },
  {
    x: 5840,
    y: -242.07910000000038,
  },
  {
    x: 5860,
    y: -219.01860000000033,
  },
  {
    x: 5880,
    y: -208.70920000000024,
  },
  {
    x: 5900,
    y: -188.63300000000027,
  },
  {
    x: 5920,
    y: -163.9447,
  },
  {
    x: 5940,
    y: -146.85280000000012,
  },
  {
    x: 5960,
    y: -126.77660000000014,
  },
  {
    x: 5980,
    y: -99.91790000000037,
  },
  {
    x: 6000,
    y: -84.45380000000023,
  },
  {
    x: 6020,
    y: -65.19150000000036,
  },
  {
    x: 6040,
    y: -46.47180000000026,
  },
  {
    x: 6060,
    y: -35.34850000000006,
  },
  {
    x: 6080,
    y: -26.395600000000286,
  },
  {
    x: 6100,
    y: -22.05480000000034,
  },
  {
    x: 6120,
    y: -17.44270000000006,
  },
  {
    x: 6140,
    y: -14.458399999999983,
  },
  {
    x: 6160,
    y: -10.660200000000259,
  },
  {
    x: 6180,
    y: -4.149000000000342,
  },
  {
    x: 6200,
    y: -1.707300000000032,
  },
  {
    x: 6220,
    y: -3.3351000000002387,
  },
  {
    x: 6240,
    y: -1.1647000000002663,
  },
  {
    x: 6260,
    y: -5.505500000000211,
  },
  {
    x: 6280,
    y: 0.46309999999994034,
  },
  {
    x: 6300,
    y: 0.46309999999994034,
  },
  {
    x: 6320,
    y: -1.707300000000032,
  },
  {
    x: 6340,
    y: 1.005699999999706,
  },
  {
    x: 6360,
    y: 0.46309999999994034,
  },
  {
    x: 6380,
    y: 1.8195999999998094,
  },
  {
    x: 6400,
    y: 0.46309999999994034,
  },
  {
    x: 6420,
    y: -1.707300000000032,
  },
  {
    x: 6440,
    y: 2.6334999999999127,
  },
  {
    x: 6460,
    y: -4.149000000000342,
  },
  {
    x: 6480,
    y: 0.46309999999994034,
  },
  {
    x: 6500,
    y: -1.707300000000032,
  },
  {
    x: 6520,
    y: -1.707300000000032,
  },
  {
    x: 6540,
    y: 1.005699999999706,
  },
  {
    x: 6560,
    y: -4.149000000000342,
  },
  {
    x: 6580,
    y: -2.5212000000001353,
  },
  {
    x: 6600,
    y: 0.46309999999994034,
  },
  {
    x: 6620,
    y: 0.46309999999994034,
  },
  {
    x: 6640,
    y: -4.149000000000342,
  },
  {
    x: 6660,
    y: -3.3351000000002387,
  },
  {
    x: 6680,
    y: -1.1647000000002663,
  },
  {
    x: 6700,
    y: -6.319400000000314,
  },
  {
    x: 6720,
    y: 0.46309999999994034,
  },
  {
    x: 6740,
    y: -5.505500000000211,
  },
  {
    x: 6760,
    y: -1.1647000000002663,
  },
  {
    x: 6780,
    y: -2.5212000000001353,
  },
  {
    x: 6800,
    y: -4.149000000000342,
  },
  {
    x: 6820,
    y: -4.149000000000342,
  },
  {
    x: 6840,
    y: -3.3351000000002387,
  },
  {
    x: 6860,
    y: -2.5212000000001353,
  },
  {
    x: 6880,
    y: -4.149000000000342,
  },
  {
    x: 6900,
    y: -1.1647000000002663,
  },
  {
    x: 6920,
    y: -2.5212000000001353,
  },
  {
    x: 6940,
    y: -2.5212000000001353,
  },
  {
    x: 6960,
    y: -4.149000000000342,
  },
  {
    x: 6980,
    y: 0.46309999999994034,
  },
  {
    x: 7000,
    y: -2.5212000000001353,
  },
  {
    x: 7020,
    y: -4.149000000000342,
  },
  {
    x: 7040,
    y: -1.1647000000002663,
  },
  {
    x: 7060,
    y: -5.505500000000211,
  },
  {
    x: 7080,
    y: 0.46309999999994034,
  },
  {
    x: 7100,
    y: -5.505500000000211,
  },
  {
    x: 7120,
    y: -1.707300000000032,
  },
  {
    x: 7140,
    y: -3.3351000000002387,
  },
  {
    x: 7160,
    y: -1.707300000000032,
  },
  {
    x: 7180,
    y: -5.505500000000211,
  },
  {
    x: 7200,
    y: -1.1647000000002663,
  },
  {
    x: 7220,
    y: -4.149000000000342,
  },
  {
    x: 7240,
    y: -3.3351000000002387,
  },
  {
    x: 7260,
    y: -1.707300000000032,
  },
  {
    x: 7280,
    y: 0.46309999999994034,
  },
  {
    x: 7300,
    y: -2.5212000000001353,
  },
  {
    x: 7320,
    y: -6.319400000000314,
  },
  {
    x: 7340,
    y: -1.1647000000002663,
  },
  {
    x: 7360,
    y: -2.5212000000001353,
  },
  {
    x: 7380,
    y: -6.319400000000314,
  },
  {
    x: 7400,
    y: -1.707300000000032,
  },
  {
    x: 7420,
    y: -5.505500000000211,
  },
  {
    x: 7440,
    y: -2.5212000000001353,
  },
  {
    x: 7460,
    y: -2.5212000000001353,
  },
  {
    x: 7480,
    y: -2.5212000000001353,
  },
  {
    x: 7500,
    y: 1.8195999999998094,
  },
  {
    x: 7520,
    y: -5.505500000000211,
  },
  {
    x: 7540,
    y: -2.5212000000001353,
  },
  {
    x: 7560,
    y: -1.1647000000002663,
  },
  {
    x: 7580,
    y: -1.1647000000002663,
  },
  {
    x: 7600,
    y: -2.5212000000001353,
  },
  {
    x: 7620,
    y: 0.46309999999994034,
  },
  {
    x: 7640,
    y: -4.149000000000342,
  },
  {
    x: 7660,
    y: -5.505500000000211,
  },
  {
    x: 7680,
    y: -4.149000000000342,
  },
  {
    x: 7700,
    y: -4.149000000000342,
  },
  {
    x: 7720,
    y: 0.46309999999994034,
  },
  {
    x: 7740,
    y: 47.1266999999998,
  },
  {
    x: 7760,
    y: 116.30819999999994,
  },
  {
    x: 7780,
    y: 196.0703999999996,
  },
  {
    x: 7800,
    y: 265.52319999999963,
  },
  {
    x: 7820,
    y: 337.68899999999985,
  },
  {
    x: 7840,
    y: 415.2808,
  },
  {
    x: 7860,
    y: 501.0115999999998,
  },
  {
    x: 7880,
    y: 563.4105999999997,
  },
  {
    x: 7900,
    y: 645.8857999999996,
  },
  {
    x: 7920,
    y: 607.0899,
  },
  {
    x: 7940,
    y: 607.0899,
  },
  {
    x: 7960,
    y: 606.2759999999998,
  },
  {
    x: 7980,
    y: 607.0899,
  },
  {
    x: 8000,
    y: 605.7333999999996,
  },
  {
    x: 8020,
    y: 606.2759999999998,
  },
  {
    x: 8040,
    y: 606.2759999999998,
  },
  {
    x: 8060,
    y: 606.2759999999998,
  },
  {
    x: 8080,
    y: 607.9037999999996,
  },
  {
    x: 8100,
    y: 606.2759999999998,
  },
  {
    x: 8120,
    y: 607.0899,
  },
  {
    x: 8140,
    y: 603.8343,
  },
  {
    x: 8160,
    y: 604.6481999999996,
  },
  {
    x: 8180,
    y: 606.2759999999998,
  },
  {
    x: 8200,
    y: 605.4620999999997,
  },
  {
    x: 8220,
    y: 608.7176999999997,
  },
  {
    x: 8240,
    y: 607.0899,
  },
  {
    x: 8260,
    y: 607.0899,
  },
  {
    x: 8280,
    y: 607.0899,
  },
  {
    x: 8300,
    y: 607.0899,
  },
  {
    x: 8320,
    y: 606.2759999999998,
  },
  {
    x: 8340,
    y: 603.0203999999999,
  },
  {
    x: 8360,
    y: 606.2759999999998,
  },
  {
    x: 8380,
    y: 607.0899,
  },
  {
    x: 8400,
    y: 606.2759999999998,
  },
  {
    x: 8420,
    y: 607.0899,
  },
  {
    x: 8440,
    y: 606.2759999999998,
  },
  {
    x: 8460,
    y: 608.9889999999996,
  },
  {
    x: 8480,
    y: 605.4620999999997,
  },
  {
    x: 8500,
    y: 605.7333999999996,
  },
  {
    x: 8520,
    y: 607.3611999999998,
  },
  {
    x: 8540,
    y: 606.2759999999998,
  },
  {
    x: 8560,
    y: 606.2759999999998,
  },
  {
    x: 8580,
    y: 606.2759999999998,
  },
  {
    x: 8600,
    y: 605.7333999999996,
  },
  {
    x: 8620,
    y: 605.7333999999996,
  },
  {
    x: 8640,
    y: 7.516899999999623,
  },
  {
    x: 8660,
    y: 5.617799999999988,
  },
  {
    x: 8680,
    y: 1.005699999999706,
  },
  {
    x: 8700,
    y: -0.07950000000028012,
  },
  {
    x: 8720,
    y: -0.07950000000028012,
  },
  {
    x: 8740,
    y: 1.005699999999706,
  },
  {
    x: 8760,
    y: 1.005699999999706,
  },
  {
    x: 8780,
    y: 1.005699999999706,
  },
  {
    x: 8800,
    y: 1.5482999999999265,
  },
  {
    x: 8820,
    y: 1.005699999999706,
  },
  {
    x: 8840,
    y: 1.005699999999706,
  },
  {
    x: 8860,
    y: 1.005699999999706,
  },
  {
    x: 8880,
    y: 1.005699999999706,
  },
  {
    x: 8900,
    y: 1.005699999999706,
  },
  {
    x: 8920,
    y: 1.005699999999706,
  },
  {
    x: 8940,
    y: 1.005699999999706,
  },
  {
    x: 8960,
    y: 1.005699999999706,
  },
  {
    x: 8980,
    y: 1.005699999999706,
  },
  {
    x: 9000,
    y: 1.005699999999706,
  },
  {
    x: 9020,
    y: 1.005699999999706,
  },
  {
    x: 9040,
    y: 1.005699999999706,
  },
  {
    x: 9060,
    y: -385.3255000000004,
  },
  {
    x: 9080,
    y: -1141.7099000000003,
  },
  {
    x: 9100,
    y: -903.5084999999999,
  },
  {
    x: 9120,
    y: -858.4727000000003,
  },
  {
    x: 9140,
    y: -893.1991000000003,
  },
  {
    x: 9160,
    y: -796.3450000000003,
  },
  {
    x: 9180,
    y: -803.6701000000003,
  },
  {
    x: 9200,
    y: -759.9908,
  },
  {
    x: 9220,
    y: -726.3496,
  },
  {
    x: 9240,
    y: -713.0559000000003,
  },
  {
    x: 9260,
    y: -704.9169000000002,
  },
  {
    x: 9280,
    y: -692.9797000000003,
  },
  {
    x: 9300,
    y: -692.1658000000002,
  },
  {
    x: 9320,
    y: -656.3542000000002,
  },
  {
    x: 9340,
    y: -646.8587000000002,
  },
  {
    x: 9360,
    y: -638.7197000000001,
  },
  {
    x: 9380,
    y: -633.2937000000002,
  },
  {
    x: 9400,
    y: -599.9238,
  },
  {
    x: 9420,
    y: -593.1413000000002,
  },
  {
    x: 9440,
    y: -587.1727000000001,
  },
  {
    x: 9460,
    y: -566.5539000000003,
  },
  {
    x: 9480,
    y: -547.0203000000001,
  },
  {
    x: 9500,
    y: -541.3230000000003,
  },
  {
    x: 9520,
    y: -517.4486000000002,
  },
  {
    x: 9540,
    y: -499.54280000000017,
  },
  {
    x: 9560,
    y: -480.2805000000003,
  },
  {
    x: 9580,
    y: -472.68409999999994,
  },
  {
    x: 9600,
    y: -452.0653000000002,
  },
  {
    x: 9620,
    y: -433.3456000000001,
  },
  {
    x: 9640,
    y: -426.8344000000002,
  },
  {
    x: 9660,
    y: -402.68870000000015,
  },
  {
    x: 9680,
    y: -385.59680000000026,
  },
  {
    x: 9700,
    y: -369.3188,
  },
  {
    x: 9720,
    y: -352.2269000000001,
  },
  {
    x: 9740,
    y: -344.0879,
  },
  {
    x: 9760,
    y: -316.4153000000001,
  },
  {
    x: 9780,
    y: -294.1687000000002,
  },
  {
    x: 9800,
    y: -277.8907000000004,
  },
  {
    x: 9820,
    y: -254.01630000000023,
  },
  {
    x: 9840,
    y: -243.70690000000013,
  },
  {
    x: 9860,
    y: -223.63070000000016,
  },
  {
    x: 9880,
    y: -207.08140000000003,
  },
  {
    x: 9900,
    y: -184.8348000000001,
  },
  {
    x: 9920,
    y: -160.41780000000017,
  },
  {
    x: 9940,
    y: -146.0389,
  },
  {
    x: 9960,
    y: -129.76090000000022,
  },
  {
    x: 9980,
    y: -102.35960000000023,
  },
  {
    x: 10000,
    y: -89.60850000000028,
  },
  {
    x: 10020,
    y: -72.51660000000038,
  },
  {
    x: 10040,
    y: -50.26999999999998,
  },
  {
    x: 10060,
    y: -36.70500000000038,
  },
  {
    x: 10080,
    y: -22.05480000000034,
  },
  {
    x: 10100,
    y: -34.534599999999955,
  },
  {
    x: 10120,
    y: -7.675900000000183,
  },
  {
    x: 10140,
    y: -13.915800000000218,
  },
  {
    x: 10160,
    y: -7.133299999999963,
  },
  {
    x: 10180,
    y: -5.505500000000211,
  },
  {
    x: 10200,
    y: -7.675900000000183,
  },
  {
    x: 10220,
    y: -1.1647000000002663,
  },
  {
    x: 10240,
    y: 0.46309999999994034,
  },
  {
    x: 10260,
    y: -3.3351000000002387,
  },
  {
    x: 10280,
    y: 1.8195999999998094,
  },
  {
    x: 10300,
    y: 1.005699999999706,
  },
  {
    x: 10320,
    y: 1.8195999999998094,
  },
  {
    x: 10340,
    y: 1.005699999999706,
  },
  {
    x: 10360,
    y: 1.8195999999998094,
  },
  {
    x: 10380,
    y: 1.005699999999706,
  },
  {
    x: 10400,
    y: 0.46309999999994034,
  },
  {
    x: 10420,
    y: -1.707300000000032,
  },
  {
    x: 10440,
    y: 1.005699999999706,
  },
  {
    x: 10460,
    y: 4.803899999999885,
  },
  {
    x: 10480,
    y: -1.707300000000032,
  },
  {
    x: 10500,
    y: -1.1647000000002663,
  },
  {
    x: 10520,
    y: -1.1647000000002663,
  },
  {
    x: 10540,
    y: -1.707300000000032,
  },
  {
    x: 10560,
    y: -1.707300000000032,
  },
  {
    x: 10580,
    y: 0.46309999999994034,
  },
  {
    x: 10600,
    y: -2.5212000000001353,
  },
  {
    x: 10620,
    y: 0.46309999999994034,
  },
  {
    x: 10640,
    y: -1.707300000000032,
  },
  {
    x: 10660,
    y: -5.505500000000211,
  },
  {
    x: 10680,
    y: 0.46309999999994034,
  },
  {
    x: 10700,
    y: -3.3351000000002387,
  },
  {
    x: 10720,
    y: -2.5212000000001353,
  },
  {
    x: 10740,
    y: -4.149000000000342,
  },
  {
    x: 10760,
    y: -3.3351000000002387,
  },
  {
    x: 10780,
    y: -1.707300000000032,
  },
  {
    x: 10800,
    y: -3.3351000000002387,
  },
  {
    x: 10820,
    y: -2.5212000000001353,
  },
  {
    x: 10840,
    y: -1.707300000000032,
  },
  {
    x: 10860,
    y: -3.3351000000002387,
  },
  {
    x: 10880,
    y: -5.505500000000211,
  },
  {
    x: 10900,
    y: -4.149000000000342,
  },
  {
    x: 10920,
    y: -5.505500000000211,
  },
  {
    x: 10940,
    y: 0.46309999999994034,
  },
  {
    x: 10960,
    y: -1.707300000000032,
  },
  {
    x: 10980,
    y: -3.3351000000002387,
  },
  {
    x: 11000,
    y: -2.5212000000001353,
  },
  {
    x: 11020,
    y: -1.707300000000032,
  },
  {
    x: 11040,
    y: -1.707300000000032,
  },
  {
    x: 11060,
    y: -6.319400000000314,
  },
  {
    x: 11080,
    y: -1.1647000000002663,
  },
  {
    x: 11100,
    y: -2.5212000000001353,
  },
  {
    x: 11120,
    y: -2.5212000000001353,
  },
  {
    x: 11140,
    y: -1.707300000000032,
  },
  {
    x: 11160,
    y: -4.149000000000342,
  },
  {
    x: 11180,
    y: -6.319400000000314,
  },
  {
    x: 11200,
    y: 0.46309999999994034,
  },
  {
    x: 11220,
    y: -2.5212000000001353,
  },
  {
    x: 11240,
    y: -2.5212000000001353,
  },
  {
    x: 11260,
    y: -2.5212000000001353,
  },
  {
    x: 11280,
    y: -2.5212000000001353,
  },
  {
    x: 11300,
    y: -5.505500000000211,
  },
  {
    x: 11320,
    y: 0.46309999999994034,
  },
  {
    x: 11340,
    y: -3.3351000000002387,
  },
  {
    x: 11360,
    y: 0.46309999999994034,
  },
  {
    x: 11380,
    y: -7.675900000000183,
  },
  {
    x: 11400,
    y: -1.707300000000032,
  },
  {
    x: 11420,
    y: -1.707300000000032,
  },
  {
    x: 11440,
    y: -1.707300000000032,
  },
  {
    x: 11460,
    y: -1.707300000000032,
  },
  {
    x: 11480,
    y: -3.3351000000002387,
  },
  {
    x: 11500,
    y: -1.1647000000002663,
  },
  {
    x: 11520,
    y: -1.1647000000002663,
  },
  {
    x: 11540,
    y: -3.3351000000002387,
  },
  {
    x: 11560,
    y: -1.1647000000002663,
  },
  {
    x: 11580,
    y: -1.1647000000002663,
  },
  {
    x: 11600,
    y: -2.5212000000001353,
  },
  {
    x: 11620,
    y: -3.3351000000002387,
  },
  {
    x: 11640,
    y: -1.707300000000032,
  },
  {
    x: 11660,
    y: -2.5212000000001353,
  },
  {
    x: 11680,
    y: -1.707300000000032,
  },
  {
    x: 11700,
    y: -1.1647000000002663,
  },
  {
    x: 11720,
    y: -6.319400000000314,
  },
  {
    x: 11740,
    y: 41.97199999999975,
  },
  {
    x: 11760,
    y: 107.08399999999983,
  },
  {
    x: 11780,
    y: 185.48969999999963,
  },
  {
    x: 11800,
    y: 257.1128999999996,
  },
  {
    x: 11820,
    y: 328.7360999999996,
  },
  {
    x: 11840,
    y: 403.8861999999999,
  },
  {
    x: 11860,
    y: 481.2066999999997,
  },
  {
    x: 11880,
    y: 548.7603999999997,
  },
  {
    x: 11900,
    y: 651.5830999999998,
  },
  {
    x: 11920,
    y: 607.9037999999996,
  },
  {
    x: 11940,
    y: 608.7176999999997,
  },
  {
    x: 11960,
    y: 607.9037999999996,
  },
  {
    x: 11980,
    y: 606.2759999999998,
  },
  {
    x: 12000,
    y: 605.4620999999997,
  },
  {
    x: 12020,
    y: 605.7333999999996,
  },
  {
    x: 12040,
    y: 607.9037999999996,
  },
  {
    x: 12060,
    y: 607.0899,
  },
  {
    x: 12080,
    y: 607.9037999999996,
  },
  {
    x: 12100,
    y: 606.2759999999998,
  },
  {
    x: 12120,
    y: 608.7176999999997,
  },
  {
    x: 12140,
    y: 608.9889999999996,
  },
  {
    x: 12160,
    y: 608.1750999999999,
  },
  {
    x: 12180,
    y: 606.2759999999998,
  },
  {
    x: 12200,
    y: 605.4620999999997,
  },
  {
    x: 12220,
    y: 606.2759999999998,
  },
  {
    x: 12240,
    y: 607.9037999999996,
  },
  {
    x: 12260,
    y: 604.6481999999996,
  },
  {
    x: 12280,
    y: 605.7333999999996,
  },
  {
    x: 12300,
    y: 607.0899,
  },
  {
    x: 12320,
    y: 603.8343,
  },
  {
    x: 12340,
    y: 603.8343,
  },
  {
    x: 12360,
    y: 608.1750999999999,
  },
  {
    x: 12380,
    y: 609.8028999999997,
  },
  {
    x: 12400,
    y: 605.4620999999997,
  },
  {
    x: 12420,
    y: 605.7333999999996,
  },
  {
    x: 12440,
    y: 607.3611999999998,
  },
  {
    x: 12460,
    y: 606.2759999999998,
  },
  {
    x: 12480,
    y: 605.7333999999996,
  },
  {
    x: 12500,
    y: 607.0899,
  },
  {
    x: 12520,
    y: 606.2759999999998,
  },
  {
    x: 12540,
    y: 605.7333999999996,
  },
  {
    x: 12560,
    y: 606.2759999999998,
  },
  {
    x: 12580,
    y: 606.2759999999998,
  },
  {
    x: 12600,
    y: 605.7333999999996,
  },
  {
    x: 12620,
    y: 606.2759999999998,
  },
  {
    x: 12640,
    y: 11.586399999999685,
  },
  {
    x: 12660,
    y: 5.617799999999988,
  },
  {
    x: 12680,
    y: 1.005699999999706,
  },
  {
    x: 12700,
    y: -0.07950000000028012,
  },
  {
    x: 12720,
    y: -0.07950000000028012,
  },
  {
    x: 12740,
    y: 1.005699999999706,
  },
  {
    x: 12760,
    y: 1.005699999999706,
  },
  {
    x: 12780,
    y: 1.005699999999706,
  },
  {
    x: 12800,
    y: 1.005699999999706,
  },
  {
    x: 12820,
    y: 1.005699999999706,
  },
  {
    x: 12840,
    y: 1.005699999999706,
  },
  {
    x: 12860,
    y: 1.005699999999706,
  },
  {
    x: 12880,
    y: 1.005699999999706,
  },
  {
    x: 12900,
    y: 1.005699999999706,
  },
  {
    x: 12920,
    y: 1.005699999999706,
  },
  {
    x: 12940,
    y: 1.005699999999706,
  },
  {
    x: 12960,
    y: 1.005699999999706,
  },
  {
    x: 12980,
    y: 1.005699999999706,
  },
  {
    x: 13000,
    y: 1.005699999999706,
  },
  {
    x: 13020,
    y: 1.005699999999706,
  },
  {
    x: 13040,
    y: 1.005699999999706,
  },
  {
    x: 13060,
    y: -265.4109000000003,
  },
  {
    x: 13080,
    y: -1111.3243000000002,
  },
  {
    x: 13100,
    y: -923.5847000000003,
  },
  {
    x: 13120,
    y: -843.5512000000003,
  },
  {
    x: 13140,
    y: -899.7103000000002,
  },
  {
    x: 13160,
    y: -816.4212000000002,
  },
  {
    x: 13180,
    y: -799.3293000000003,
  },
  {
    x: 13200,
    y: -752.3944000000001,
  },
  {
    x: 13220,
    y: -725.5357000000004,
  },
  {
    x: 13240,
    y: -716.5828000000001,
  },
  {
    x: 13260,
    y: -709.2577000000001,
  },
  {
    x: 13280,
    y: -696.5066000000002,
  },
  {
    x: 13300,
    y: -689.1815000000001,
  },
  {
    x: 13320,
    y: -673.4461000000001,
  },
  {
    x: 13340,
    y: -653.3699000000001,
  },
  {
    x: 13360,
    y: -641.7040000000002,
  },
  {
    x: 13380,
    y: -627.3251,
  },
  {
    x: 13400,
    y: -603.7220000000002,
  },
  {
    x: 13420,
    y: -593.9552000000003,
  },
  {
    x: 13440,
    y: -575.5068000000001,
  },
  {
    x: 13460,
    y: -565.7400000000002,
  },
  {
    x: 13480,
    y: -544.8499000000002,
  },
  {
    x: 13500,
    y: -542.6795000000002,
  },
  {
    x: 13520,
    y: -521.7894000000001,
  },
  {
    x: 13540,
    y: -503.8836000000001,
  },
  {
    x: 13560,
    y: -491.40380000000005,
  },
  {
    x: 13580,
    y: -463.7312000000002,
  },
  {
    x: 13600,
    y: -446.09670000000006,
  },
  {
    x: 13620,
    y: -434.1595000000002,
  },
  {
    x: 13640,
    y: -412.45550000000003,
  },
  {
    x: 13660,
    y: -398.3479000000002,
  },
  {
    x: 13680,
    y: -385.59680000000026,
  },
  {
    x: 13700,
    y: -369.3188,
  },
  {
    x: 13720,
    y: -342.46010000000024,
  },
  {
    x: 13740,
    y: -327.8099000000002,
  },
  {
    x: 13760,
    y: -315.87270000000035,
  },
  {
    x: 13780,
    y: -291.9983000000002,
  },
  {
    x: 13800,
    y: -281.6889000000001,
  },
  {
    x: 13820,
    y: -262.9692,
  },
  {
    x: 13840,
    y: -248.04770000000008,
  },
  {
    x: 13860,
    y: -224.98720000000003,
  },
  {
    x: 13880,
    y: -207.89530000000013,
  },
  {
    x: 13900,
    y: -189.98950000000013,
  },
  {
    x: 13920,
    y: -171.54110000000037,
  },
  {
    x: 13940,
    y: -146.85280000000012,
  },
  {
    x: 13960,
    y: -125.42010000000028,
  },
  {
    x: 13980,
    y: -110.49860000000035,
  },
  {
    x: 14000,
    y: -94.2206000000001,
  },
  {
    x: 14020,
    y: -68.17579999999998,
  },
  {
    x: 14040,
    y: -51.083900000000085,
  },
  {
    x: 14060,
    y: -35.34850000000006,
  },
  {
    x: 14080,
    y: -31.550300000000334,
  },
  {
    x: 14100,
    y: -28.56600000000026,
  },
  {
    x: 14120,
    y: -7.133299999999963,
  },
  {
    x: 14140,
    y: -18.256600000000162,
  },
  {
    x: 14160,
    y: -7.133299999999963,
  },
  {
    x: 14180,
    y: -9.30370000000039,
  },
  {
    x: 14200,
    y: -6.319400000000314,
  },
  {
    x: 14220,
    y: -3.3351000000002387,
  },
  {
    x: 14240,
    y: 1.8195999999998094,
  },
  {
    x: 14260,
    y: 0.46309999999994034,
  },
  {
    x: 14280,
    y: -2.5212000000001353,
  },
  {
    x: 14300,
    y: -2.5212000000001353,
  },
  {
    x: 14320,
    y: 1.005699999999706,
  },
  {
    x: 14340,
    y: -1.1647000000002663,
  },
  {
    x: 14360,
    y: 0.46309999999994034,
  },
  {
    x: 14380,
    y: -1.1647000000002663,
  },
  {
    x: 14400,
    y: 2.6334999999999127,
  },
  {
    x: 14420,
    y: -1.707300000000032,
  },
  {
    x: 14440,
    y: -2.5212000000001353,
  },
  {
    x: 14460,
    y: -1.1647000000002663,
  },
  {
    x: 14480,
    y: 1.8195999999998094,
  },
  {
    x: 14500,
    y: 0.46309999999994034,
  },
  {
    x: 14520,
    y: -1.707300000000032,
  },
  {
    x: 14540,
    y: -1.1647000000002663,
  },
  {
    x: 14560,
    y: -1.707300000000032,
  },
  {
    x: 14580,
    y: -1.1647000000002663,
  },
  {
    x: 14600,
    y: 0.46309999999994034,
  },
  {
    x: 14620,
    y: -2.5212000000001353,
  },
  {
    x: 14640,
    y: 1.005699999999706,
  },
  {
    x: 14660,
    y: -2.5212000000001353,
  },
  {
    x: 14680,
    y: 0.46309999999994034,
  },
  {
    x: 14700,
    y: -2.5212000000001353,
  },
  {
    x: 14720,
    y: -7.675900000000183,
  },
  {
    x: 14740,
    y: -2.5212000000001353,
  },
  {
    x: 14760,
    y: -3.3351000000002387,
  },
  {
    x: 14780,
    y: -4.149000000000342,
  },
  {
    x: 14800,
    y: -3.3351000000002387,
  },
  {
    x: 14820,
    y: -1.1647000000002663,
  },
  {
    x: 14840,
    y: -5.505500000000211,
  },
  {
    x: 14860,
    y: -4.149000000000342,
  },
  {
    x: 14880,
    y: -3.3351000000002387,
  },
  {
    x: 14900,
    y: -5.505500000000211,
  },
  {
    x: 14920,
    y: -5.505500000000211,
  },
  {
    x: 14940,
    y: -1.1647000000002663,
  },
  {
    x: 14960,
    y: -3.3351000000002387,
  },
  {
    x: 14980,
    y: -5.505500000000211,
  },
  {
    x: 15000,
    y: 0.46309999999994034,
  },
  {
    x: 15020,
    y: -4.149000000000342,
  },
  {
    x: 15040,
    y: -3.3351000000002387,
  },
  {
    x: 15060,
    y: -2.5212000000001353,
  },
  {
    x: 15080,
    y: -3.3351000000002387,
  },
  {
    x: 15100,
    y: -3.3351000000002387,
  },
  {
    x: 15120,
    y: 1.005699999999706,
  },
  {
    x: 15140,
    y: -5.505500000000211,
  },
  {
    x: 15160,
    y: -6.319400000000314,
  },
  {
    x: 15180,
    y: -3.3351000000002387,
  },
  {
    x: 15200,
    y: -3.3351000000002387,
  },
  {
    x: 15220,
    y: 0.46309999999994034,
  },
  {
    x: 15240,
    y: -5.505500000000211,
  },
  {
    x: 15260,
    y: -1.1647000000002663,
  },
  {
    x: 15280,
    y: 0.46309999999994034,
  },
  {
    x: 15300,
    y: -6.319400000000314,
  },
  {
    x: 15320,
    y: 1.005699999999706,
  },
  {
    x: 15340,
    y: -3.3351000000002387,
  },
  {
    x: 15360,
    y: -7.675900000000183,
  },
  {
    x: 15380,
    y: -2.5212000000001353,
  },
  {
    x: 15400,
    y: -4.149000000000342,
  },
  {
    x: 15420,
    y: -2.5212000000001353,
  },
  {
    x: 15440,
    y: -1.1647000000002663,
  },
  {
    x: 15460,
    y: -1.707300000000032,
  },
  {
    x: 15480,
    y: 1.005699999999706,
  },
  {
    x: 15500,
    y: -2.5212000000001353,
  },
  {
    x: 15520,
    y: 1.005699999999706,
  },
  {
    x: 15540,
    y: -6.319400000000314,
  },
  {
    x: 15560,
    y: -5.505500000000211,
  },
  {
    x: 15580,
    y: 0.46309999999994034,
  },
  {
    x: 15600,
    y: 0.46309999999994034,
  },
  {
    x: 15620,
    y: -2.5212000000001353,
  },
  {
    x: 15640,
    y: -5.505500000000211,
  },
  {
    x: 15660,
    y: -1.1647000000002663,
  },
  {
    x: 15680,
    y: -2.5212000000001353,
  },
  {
    x: 15700,
    y: -4.149000000000342,
  },
  {
    x: 15720,
    y: 1.8195999999998094,
  },
  {
    x: 15740,
    y: -2.792500000000018,
  },
  {
    x: 15760,
    y: 102.20059999999967,
  },
  {
    x: 15780,
    y: 180.33500000000004,
  },
  {
    x: 15800,
    y: 252.22949999999992,
  },
  {
    x: 15820,
    y: 323.8526999999999,
  },
  {
    x: 15840,
    y: 399.00279999999975,
  },
  {
    x: 15860,
    y: 471.43989999999985,
  },
  {
    x: 15880,
    y: 552.8298999999997,
  },
  {
    x: 15900,
    y: 617.9418999999998,
  },
  {
    x: 15920,
    y: 607.9037999999996,
  },
  {
    x: 15940,
    y: 608.7176999999997,
  },
  {
    x: 15960,
    y: 605.7333999999996,
  },
  {
    x: 15980,
    y: 612.7871999999998,
  },
];
